<template>
  <div class="process-sidebar">
    <div class="logo-brand">
      <img src="/img/onboard-driver/Logo_AhaDriver.svg" alt />
    </div>
    <div class="content__process-sidebar">
      <div class="steps">
        <div class="step is-flex" v-for="(step, index) in steps" :key="index">
          <img :src="step.icon" />
          <p :class="step.class_name">
            {{ step.name }}
          </p>
          <img v-if="step.arrow_icon"
            class="arrow-icon"
            :src="step.arrow_icon"
            alt
          />
        </div>
      </div>
      <div @click="signOut" v-if="$route.name === null || !($route.name === 'signin' || $route.name === 'signup' || $route.name === 'activate') " class="sign-out has-text-centered">
        <p>Đăng xuất</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { removeItemStorage } from "@/plugins/utils"

const STEPS = [
  {
    id: 1,
    title: "signup",
    icon: "plus"
  },
  {
    id: 2,
    title: "document",
    icon: "file"
  },
  {
    id: 3,
    title: "profile",
    icon: "user-info"
  },
  {
    id: 4,
    title: "training",
    icon: "training"
  },
  {
    id: 5,
    title: "contract",
    icon: "contract"
  }
]

export default {
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(["activeStep", "supplierToken", "supplierProfile"]),
    steps () {
      let result = []
      STEPS.forEach(s => {
        let icon, arrowIcon, className
        if (s.id < this.activeStep) {
          icon = `/img/icons/${s.icon}-success.svg`
          arrowIcon = '/img/icons/success.svg'
          className = 'success'
        } else if (s.id === this.activeStep) {
          icon = `/img/icons/${s.icon}-process.svg`
          arrowIcon = '/img/icons/arrow-processing.svg'
          className = 'active'
        } else {
          icon = `/img/icons/${s.icon}.svg`
        }

        result.push({
          ...s,
          icon,
          arrow_icon: arrowIcon,
          class_name: className,
          name: this.$t(`driver_onboarding.step_progress_bar.${s.title}`)
        })
      })

      return result
    }
  },
  methods: {
    goToStep (name) {
      this.$router.push({
        name
      })
      this.$forceUpdate()
    },

    signOut() {
      const token = this.supplierToken
      if(token){
        this.$store.dispatch('logout', token)
          .then(response => {
            if(response && response.status === 200) {
              this.$deleteCookie(this.$constants.COOKIE_SUPPLIER_TOKEN)
              this.$deleteCookie('timer');
              removeItemStorage(this.$constants.LOCAL_STORAGE_SUPPLIER)

              this.$router.push({name : 'signup'})
              this.$buefy.notification.open({
                message: this.$t("driver_onboarding.logout_success"),
                type: "is-success",
                duration: 3000,
                position: "is-bottom"
              });
            }
          }).catch(error => {
            console.log(error)
          })
      }
    }
  },
  mounted() {
    this.$root.$on("moveToNextStep", () => {
      const nextStepIndex = this.$store.getters.activeStep + 1
      const routers = this.$router.options && this.$router.options.routes
      const foundStep = routers && routers.find(s => s.meta && s.meta.step_id === nextStepIndex)
      if (foundStep) {
        this.goToStep(foundStep.name)
      }
    });
  },
};
</script>

<style lang="scss" scoped>
.process-sidebar {
  min-height: 100vh;
  .logo-brand {
    width: 100%;
    height: 80px;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
    position: relative;

    img {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  .content__process-sidebar {
    background-color: #f2f4f8;
    min-height: calc(100vh - 80px);
    position: relative;

    .steps {
      padding-top: 24px;
      max-width: 290px;
      margin: 0 auto;
      z-index: 2;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        width: 2px;
        height: 340px;
        background-color: #c4c4c4;
        left: 9%;
      }

      .step {
        width: 100%;
        height: 50px;
        margin-bottom: 24px;
        background-color: #fff;
        border-radius: 4px;
        z-index: 2;
        position: relative;
        align-items: center;

        img:first-child {
          margin: 0 17px;
        }

        p {
          color: #7a8189;
          font-weight: 500;
        }
        p.active {
          color: #ff8200;
        }
        p.success {
          color: #1dc05e;
        }

        .arrow-icon {
          position: absolute;
          right: 5%;
        }
      }
    }
    .sign-out{
      // width: 290px;
      position: absolute;
      bottom: 0;
      right: 33.33333%;
      transform: translate(-50%,-50%);

      p{
        cursor: pointer;
        color: #ff8200;
        font-weight: 500;
      }
    }
  }
}

@media screen and (min-width: 320px) and (max-width: 768px) {
  .process-sidebar {
    display: none;
    // .content__process-sidebar{
    //   display: none;
    // }
  }
}
@media screen and (min-width: 769px) and (max-width: 1366px) {
  .process-sidebar {
    .content__process-sidebar{
      .sign-out{
        display: none;
      }
      .steps{
        padding: 24px;

        &::after{
          left: 19%;
        }
        .step {
          p{
            font-size: 14px;
          }
        }
      }
    }
  }
}
</style>